import {
  LocalDispatch,
  WebChatMiddlewareAction,
  WebChatMiddlewareNext,
} from '../types'

export type { LocalDispatch }

export const userActivityHistoryMiddleware =
  (dispatch: LocalDispatch) =>
  () =>
  (next: WebChatMiddlewareNext) =>
  (action: WebChatMiddlewareAction) => {
    const { activity } = action.payload ?? {}

    if (
      activity &&
      activity.type === 'message' &&
      activity.from?.role === 'user' &&
      activity.id !== undefined
    ) {
      dispatch('UPDATE_USER_ACTIVITY_HISTORY', activity.id)
    }

    return next(action)
  }
